import { render, staticRenderFns } from "./ArticlePreviewTemplate.vue?vue&type=template&id=4ff6fd44&scoped=true"
import script from "./ArticlePreviewTemplate.vue?vue&type=script&lang=js"
export * from "./ArticlePreviewTemplate.vue?vue&type=script&lang=js"
import style0 from "./ArticlePreviewTemplate.vue?vue&type=style&index=0&id=4ff6fd44&prod&scoped=true&lang=css"
import style1 from "./ArticlePreviewTemplate.vue?vue&type=style&index=1&id=4ff6fd44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff6fd44",
  null
  
)

export default component.exports